'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../../../../styleInject.js');

var css_248z = ".ItemDisclosure-module_itemsList__tw1Bi{container-type:inline-size;list-style:none;margin:0;padding:0}.ItemDisclosure-module_item__2lupq{justify-items:center;margin:0;padding:0}@container (min-width: 300px){.ItemDisclosure-module_item__2lupq{grid-template-columns:1fr 1fr;justify-items:start}}";
var styles = {"itemsList":"ItemDisclosure-module_itemsList__tw1Bi","item":"ItemDisclosure-module_item__2lupq"};
styleInject["default"](css_248z, '4aef9d75-575b-41cc-9ff9-722f259d9f6c');

exports["default"] = styles;
